<app-cc-table-edit body #ccTable [transPartKey]="transPartKey"
              [tableConfig]="tableConfig" [headerButtonConfig]="headerButtonConfig"
              [records]="records" [totalRecords]="totalRecords" [loading]="tableLoading"
              (onRowDblClick)="onRowDblClick($event)"
              [fieldName]="'id'" [fieldId]="'id'"
              [defaultSortField]="'creationDate'" [defaultSortOrder]="1"
>
<!--  [currentRequest]="tableCurrentRequest"  (loadRecordsEvent)="needLoadRecords($event)"-->


<!--  <span toolbar-left style="margin-left: 20px !important;">-->
<!--      <i class="toolbar-separator fa fa-diamond"></i>-->
<!--  </span>-->
<!--  <span toolbar-left style="margin-left: 20px !important;">-->
<!--        <button type="button" class="btn btn-primary" (click)="">-->
<!--          <i class="fa fa-edit fa-lg"></i> Edit Rate-->
<!--      </button>-->
<!--  </span>-->
</app-cc-table-edit>
